import React, { useState } from 'react'
import Image from 'next/image'
import { ThemeProvider } from 'styled-components'

import { formatIngredientAmount } from '../../helpers'
import { useTranslation } from '../../contexts/I18nContext'
import useMeasureSystem from '../../hooks/useMeasureSystem'
import { COLORS, THEME } from '../../styles'
import Icon from '../Icon'

import Styled from './Ingredient.styled'

const Ingredient = ({
  additionalMeasures,
  alt,
  children,
  className,
  coversCount,
  imageUrl,
  isOptional,
  name,
  onClick,
  quantity,
  quantityPerCover,
  size,
  unit,
  variant,
}) => {
  const [hasImageError, setHasImageError] = useState(false)
  const { t } = useTranslation()

  const amountsAndUnits = [
    { unit, amount: coversCount * quantityPerCover },
    ...(additionalMeasures || []).map((am) => ({
      unit: am.unit,
      amount: coversCount * am.amount,
    })),
  ]

  const displayQuantity =
    quantityPerCover && amountsAndUnits && amountsAndUnits.length > 0

  const { measureSystem } = useMeasureSystem()

  return (
    <ThemeProvider theme={{ variant, size }}>
      <Styled className={className} onClick={onClick}>
        <Styled.imageContainer
          standaloneImage={
            !isOptional && !children && !displayQuantity && !name
          }
        >
          <Styled.image>
            {!imageUrl || hasImageError ? (
              <Styled.missingImage>
                <Icon
                  name={size === 'xSmall' ? 'my-recipes-24' : 'my-recipes-32'}
                  width={size === 'xSmall' ? 24 : 32}
                  height={size === 'xSmall' ? 24 : 32}
                  fill={
                    variant === 'print'
                      ? COLORS.black
                      : THEME.COLORS.foreground.secondary
                  }
                />
              </Styled.missingImage>
            ) : (
              <Image
                src={imageUrl}
                alt={alt || name}
                fill
                style={{ objectFit: 'contain', objectPosition: 'center' }}
                onError={() => setHasImageError(true)}
              />
            )}
          </Styled.image>
          {isOptional ? (
            <Styled.optional>{t('RECIPE.OPTIONAL')}</Styled.optional>
          ) : null}
        </Styled.imageContainer>
        {children ? <Styled.children>{children}</Styled.children> : null}
        {displayQuantity ? (
          <Styled.quantity>
            {formatIngredientAmount({
              amountsAndUnits,
              measureSystem,
            })}
          </Styled.quantity>
        ) : quantity ? (
          <Styled.quantity>{quantity}</Styled.quantity>
        ) : null}
        {name ? <Styled.name>{name}</Styled.name> : null}
      </Styled>
    </ThemeProvider>
  )
}

Ingredient.defaultProps = {
  variant: 'main',
  size: 'normal',
}

export default Ingredient
